import React, { memo, useState } from 'react'

import { Link } from 'gatsby'

import Img from '../../../Img'

import Tag from '../../../Tag'

import LinkToAuthor from '../../../author/LinkToAuthor'

import { Twitter } from '../../../../images/svg/twitter'
import { Facebook } from '../../../../images/svg/facebook'
import { Linkedin } from '../../../../images/svg/linkedin'

import { QUERY_KEY_TYPE } from '../../../../slices/RecentArticlesSection'

import { linkResolver } from '../../../../utils/linkResolver'

const ArticleInfo = ({ context, data: sliceData }) => {
  const { author, data, tags, share, type } = context
  return (
    <div className="article-info">
      <BlogAuthor
        data={author}
        page={data}
        title={sliceData.author_section_title1.text}
      />
      <Tags
        data={tags}
        title={sliceData.tags_section_title1.text}
        type={type}
      />
      <Share data={share} title={sliceData.share_section_title1.text} />
    </div>
  )
}

export default memo(ArticleInfo)

const BlogAuthor = ({ data, page, title }) => {
  const [isOpen, setIsOpen] = useState(false)
  const author = data.author.document.data

  return (
    <div className="blog-author">
      <div
        className={`p p-20 title  ${isOpen ? 'open' : ''}`}
        onClick={() => {
          setIsOpen(!isOpen)
        }}
      >
        {title}
      </div>
      <LinkToAuthor
        to={linkResolver(data.author)}
        data={{
          type: page.page.article_overview,
          article: page.data.prismicArticlePage,
        }}
      >
        <div className="author-box">
          <Img
            image={author?.photo?.gatsbyImageData}
            alt={author?.photo?.alt}
            className="author-image"
          />
          <div>
            <p className="author-name p-14">{author?.name}</p>
            <p className="author-position p p-14">{author?.position}</p>
          </div>
        </div>
      </LinkToAuthor>
    </div>
  )
}

const Tags = ({ data, title, type }) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div className="blog-tags">
      <div
        className={`p p-20 title  ${isOpen ? 'open' : ''}`}
        onClick={() => {
          setIsOpen(!isOpen)
        }}
      >
        {title}
      </div>
      <div className="blog-tags-list">
        {data.tags?.map(({ article_category }) => (
          <Link
            to={`/${type}/search/?${QUERY_KEY_TYPE}=${encodeURIComponent(
              article_category,
            )}`}
          >
            <Tag
              key={article_category}
              text={article_category}
              type={article_category}
            />
          </Link>
        ))}
      </div>
    </div>
  )
}

const Share = ({ data, title: sectionTitle }) => {
  const [isOpen, setIsOpen] = useState(false)
  const url = typeof window !== 'undefined' ? window.location.toString() : ''
  const title = `Santorini - ${data.post.title.text}`
  const tweet = `${title} ${url}`

  return (
    <div className="blog-share">
      <div
        className={`p p-20 title  ${isOpen ? 'open' : ''}`}
        onClick={() => {
          setIsOpen(!isOpen)
        }}
      >
        {sectionTitle}
      </div>
      <div className="blog-share-list">
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            url,
          )}`}
          className="blog-share-link"
          target="_blank"
        >
          <Facebook />
        </a>
        <a
          href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
            tweet,
          )}`}
          className="blog-share-link"
          target="_blank"
        >
          <Twitter />
        </a>

        <a
          href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
            url,
          )}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(
            data.short_description,
          )}&source=Santorini`}
          className="blog-share-link"
          target="_blank"
        >
          <Linkedin />
        </a>
      </div>
    </div>
  )
}
